import styled from 'styled-components/macro';

import { StyledDiv } from 'components/base/AnimatedLoadingWrapper';

export const HeaderContainer = styled(StyledDiv)`
  display: flex;
  align-items: center;
  padding: calc(100px - ${({ theme }): string => theme.spacing.xlarge}) 0
    calc(55px - ${({ theme }): string => theme.spacing.xlarge}) 0;
  transition: ${({ theme }): string =>
    `opacity ${theme.transitionDuration} ${theme.timingFunction}`};
  opacity: ${({ loading }): number => (loading ? 0 : 1)};
`;

export const Header = styled('header')`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  align-items: center;
  padding: ${({ theme }): string => theme.spacing.xlarge} 0;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 40em) {
    text-align: left;
    flex-flow: row nowrap;
    justify-content: center;
  }
`;

export const ContentWrapper = styled('div')`
  @media screen and (min-width: 40em) {
    width: auto;
  }
`;

export const MobileWrapper = styled('div')`
  text-align: left;
  padding-left: 20px;
  @media screen and (min-width: 40em) {
    text-align: unset;
    padding-left: unset;
  }
`;

export const IconWrapper = styled('div')`
  @media screen and (min-width: 40em) {
    margin-right: 22px;
    margin-bottom: -3px;
  }
`;

export const SmallTitle = styled('div')`
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 11px;
  font-weight: 600;
`;

export const Title = styled('div')`
  font-size: 20px;
  line-height: 24px;

  @media screen and (min-width: 40em) {
    font-size: 40px;
    line-height: 48px;
  }
`;
